export function sanitizeDomain(domain) {
  return domain
    .replace(/(^\w+:|^)\/\//, '')
    .replace(':', '')
    .split('/')[0];
}
